// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Badge Styles */
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: var(--font-weight-semibold);
  border-radius: var(--radius-full);
  white-space: nowrap;
  transition: all var(--transition-base);
}

/* Badge Sizes */
.badge-sm {
  padding: var(--space-xs) var(--space-sm);
  font-size: var(--font-size-xs);
}

.badge-md {
  padding: var(--space-sm) var(--space-md);
  font-size: var(--font-size-sm);
}

.badge-lg {
  padding: var(--space-md) var(--space-lg);
  font-size: var(--font-size-base);
}

/* Badge Variants */
.badge-default {
  background: var(--color-gray);
  color: var(--color-white);
}

.badge-primary {
  background: var(--color-primary);
  color: var(--color-white);
}

.badge-success {
  background: var(--color-success);
  color: var(--color-white);
}

.badge-error {
  background: var(--color-error);
  color: var(--color-white);
}

.badge-warning {
  background: var(--color-warning);
  color: var(--color-dark);
}

.badge-info {
  background: var(--color-info);
  color: var(--color-white);
}

/* Rarity badges (game-specific) */
.badge-common {
  background: #95a5a6;
  color: var(--color-white);
}

.badge-rare {
  background: #3498db;
  color: var(--color-white);
}

.badge-epic {
  background: #9b59b6;
  color: var(--color-white);
}

.badge-legendary {
  background: linear-gradient(135deg, #f39c12 0%, #f1c40f 100%);
  color: var(--color-dark);
  box-shadow: 0 0 15px rgba(243, 156, 18, 0.5);
  animation: glow 2s ease-in-out infinite;
}

.badge.limited {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: var(--color-white);
  box-shadow: 0 0 15px rgba(231, 76, 60, 0.5);
  font-weight: bold;
}

@keyframes glow {

  0%,
  100% {
    box-shadow: 0 0 15px rgba(243, 156, 18, 0.5);
  }

  50% {
    box-shadow: 0 0 25px rgba(243, 156, 18, 0.8);
  }
}

/* Badge Dot */
.badge-dot {
  padding: 0;
  width: 8px;
  height: 8px;
  min-width: 8px;
  min-height: 8px;
  font-size: 0;
}

.badge-dot.badge-md {
  width: 10px;
  height: 10px;
  min-width: 10px;
  min-height: 10px;
}

.badge-dot.badge-lg {
  width: 12px;
  height: 12px;
  min-width: 12px;
  min-height: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Badge.css"],"names":[],"mappings":"AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,iCAAiC;EACjC,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,gBAAgB;AAChB;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,wBAAwB;EACxB,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;;EAEE;;IAEE,4CAA4C;EAC9C;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA,cAAc;AACd;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["@import '../../styles/variables.css';\n\n/* Base Badge Styles */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: var(--font-weight-semibold);\n  border-radius: var(--radius-full);\n  white-space: nowrap;\n  transition: all var(--transition-base);\n}\n\n/* Badge Sizes */\n.badge-sm {\n  padding: var(--space-xs) var(--space-sm);\n  font-size: var(--font-size-xs);\n}\n\n.badge-md {\n  padding: var(--space-sm) var(--space-md);\n  font-size: var(--font-size-sm);\n}\n\n.badge-lg {\n  padding: var(--space-md) var(--space-lg);\n  font-size: var(--font-size-base);\n}\n\n/* Badge Variants */\n.badge-default {\n  background: var(--color-gray);\n  color: var(--color-white);\n}\n\n.badge-primary {\n  background: var(--color-primary);\n  color: var(--color-white);\n}\n\n.badge-success {\n  background: var(--color-success);\n  color: var(--color-white);\n}\n\n.badge-error {\n  background: var(--color-error);\n  color: var(--color-white);\n}\n\n.badge-warning {\n  background: var(--color-warning);\n  color: var(--color-dark);\n}\n\n.badge-info {\n  background: var(--color-info);\n  color: var(--color-white);\n}\n\n/* Rarity badges (game-specific) */\n.badge-common {\n  background: #95a5a6;\n  color: var(--color-white);\n}\n\n.badge-rare {\n  background: #3498db;\n  color: var(--color-white);\n}\n\n.badge-epic {\n  background: #9b59b6;\n  color: var(--color-white);\n}\n\n.badge-legendary {\n  background: linear-gradient(135deg, #f39c12 0%, #f1c40f 100%);\n  color: var(--color-dark);\n  box-shadow: 0 0 15px rgba(243, 156, 18, 0.5);\n  animation: glow 2s ease-in-out infinite;\n}\n\n.badge.limited {\n  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n  color: var(--color-white);\n  box-shadow: 0 0 15px rgba(231, 76, 60, 0.5);\n  font-weight: bold;\n}\n\n@keyframes glow {\n\n  0%,\n  100% {\n    box-shadow: 0 0 15px rgba(243, 156, 18, 0.5);\n  }\n\n  50% {\n    box-shadow: 0 0 25px rgba(243, 156, 18, 0.8);\n  }\n}\n\n/* Badge Dot */\n.badge-dot {\n  padding: 0;\n  width: 8px;\n  height: 8px;\n  min-width: 8px;\n  min-height: 8px;\n  font-size: 0;\n}\n\n.badge-dot.badge-md {\n  width: 10px;\n  height: 10px;\n  min-width: 10px;\n  min-height: 10px;\n}\n\n.badge-dot.badge-lg {\n  width: 12px;\n  height: 12px;\n  min-width: 12px;\n  min-height: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
